<template>
	<div class="nav-top-wrap">
		<ul class="menu-wrap">
			<li class="menu" @click="changeItem(item)" v-for="(item,index) in navList" :key="index" :class="[activePath==item.linkRoute?'active':'']">{{item.menuName}}</li>
		</ul>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post, ajaxParam} from '@/units/request.js'
	export default {
		name: 'navTopMain',
		data() {
			return {
				activePath: '/home',
			navList: [
					{
						menuName: '首页',
						linkRoute: '/home'
					},
					{
						menuName: '圈子',
						linkRoute: '/circle'
					},
					{
						menuName: '活动专区',
						linkRoute: '/activity'
					},
					// {
					// 	menuName: '大赛专区',
					// 	linkRoute: '/competition'
					// },
					{
						menuName: '产品',
						linkRoute: 'https://www.kylinos.cn/productPc/'
					}
					// {
					// 	menuName: '积分兑换区',
					// 	linkRoute: '/a'
					// }
				],
			}
		},
		mounted() {
			setTimeout(res=>{
				this.navList.forEach((item,index)=>{
					if(item.linkRoute==this.activePath) {
						let nav = document.querySelectorAll('.menu')
						nav.forEach((item)=>{
							item.className = 'menu'
						})
						nav[index].className = 'menu active'
					}
				})
			},300)
		},
		watch: {
			$route(to, from) {
				this.userId = localStorage.getItem('userId')
				let path = to.path
				this.activePath = path
				let userInfo = localStorage.getItem('user')
				this.userInfo = JSON.parse(userInfo)
				window.scrollTo(0, 0)
			}
		},
		methods: {
			//切换导航菜单
			changeItem(item) {
				if(item.linkRoute.indexOf('https')>-1) {
					window.open(item.linkRoute,'_blank')
				} else {
					this.$router.push({
						path: item.linkRoute
					}, () => {})
				}

			}
		},
		created() {
			this.userId = localStorage.getItem('userId')
			let userInfo = localStorage.getItem('user')
			this.userInfo = JSON.parse(userInfo)
			this.activePath = this.$route.fullPath
		}
	}
</script>

<style scoped lang="less">
	ul{
		display: flex;
		align-items: center;
		font-size: 18px;
		font-family: 'SourceHanSansCN-Regular', 'Source Han Sans CN', 'Noto Sans SC', sans-serif;
		gap: 8px;
		li{
			padding: 8px 24px;
			margin-left: 0;
			line-height: 22px;
			color: rgba(255,255,255,1);
			border-radius: 19px;
			border-bottom: none;
			cursor: pointer;
			transition: all 0.2s ease;
			&:hover{
				background: rgba(255,255,255,0.1);
			}
		}
		li.active{
			color: #fff;
			font-weight: 400;
			background: #DD0515;
		}
	}
</style>
